import { useEffect } from "react";
import { Layout, Affix, FloatButton } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import { useHotkeys } from "react-hotkeys-hook";
import { getProductDetails } from "../../service/service";
import { useDispatch, useSelector } from "react-redux";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children, title = "", setCollapse = () => {}, collapse }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const shopData = useSelector((state) => state.shopDetails);

  // useHotkeys("ctrl + F1", () => {
  //   alert("F1");
  // });
  useHotkeys("ctrl+1", () => navigate("/dashboard"));
  useHotkeys("ctrl+2", () => navigate("/billing"));
  useHotkeys("ctrl+3", () => navigate("/dashboard/shop-items"));
  useHotkeys("ctrl+4", () => navigate("/dashboard/stock-value-report"), [
    "alt",
  ]);
  useHotkeys("ctrl+5", () => navigate("/dashboard/loyalty"));
  useHotkeys("ctrl+6", () => navigate("/dashboard/customer-management"), [
    "ctrl",
  ]);
  useHotkeys("ctrl+7", () => navigate("/dashboard/vendor-management"), [
    "ctrl",
  ]);

  useHotkeys("ctrl + 8", () => {
    navigate("/dashboard/employeeAccess");
  });
  useHotkeys("ctrl + 9", () => {
    navigate("/dashboard/settings");
  });
  // useHotkeys('ctrl+F10', () =>  navigate("/dashboard/cash-management"), ['ctrl'])
  useHotkeys("ctrl+12", () => navigate("/dashboard/employeeAccess"), ["ctrl"]);
  useHotkeys("alt+F12", () => navigate("/dashboard/settings"));

  useEffect(() => {
    document.addEventListener("blur", () => {
      console.log("Window is no longer focused");
    });

    document.addEventListener("focus", () => {
      console.log("Window is focused again");
    });
    document.addEventListener("visibilitychange", (event) => {
      console.log("visibilitychange is no longer focused", event);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async (shopId) => {
      if (shopId) {
        try {
          let product = await getProductDetails(shopId, shopData.empId);
          if (product.products) {
            const addToLocalStroage = product?.products?.map((i) => {
              let label = i.productName;
              if (
                i.unitOfMeasurment !== "Others" &&
                i.unitOfMeasurment !== "" &&
                !i.unitOfMeasurment !== true
              ) {
                label = `${i.productName} (${i.unitOfMeasurment})`;
              }
              return {
                id: i.productId,
                name: label,
                eanCode: i.productEANCode,
                productCode: i.productCode,
                color: i.color,
                size: i.size,
                value: i.productName.toLowerCase(),
              };
            });
            dispatch({
              type: "SET_PRODUCTS_SEARCH",
              payload: addToLocalStroage,
            });
            dispatch({
              type: "SET_PRODUCT_LIST",
              payload: product.products,
            });
          }
          if (Array.isArray(product)) {
            const addToLocalStroage = product?.map((i) => {
              let label = i.productName;
              if (
                i.unitOfMeasurment !== "Others" &&
                i.unitOfMeasurment !== "" &&
                !i.unitOfMeasurment !== true
              ) {
                label = `${i.productName} (${i.unitOfMeasurment})`;
              }
              return {
                id: i.productId,
                name: label,
                eanCode: i.productEANCode,
                productCode: i.productCode,
                color: i.color,
                size: i.size,
                value: i.productName.toLowerCase(),
              };
            });
            dispatch({
              type: "SET_PRODUCTS_SEARCH",
              payload: addToLocalStroage,
            });
            dispatch({
              type: "SET_PRODUCT_LIST",
              payload: product,
            });
          }
        } catch (err) {
          console.log("err222", err);
        }
      }
    })(shopData.shopId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopData.empId, shopData.shopId]);

  return (
    <Layout className={"layout-dashboard"}>
      <Sider
        breakpoint="lg"
        collapsedWidth="120px"
        id="sidebar"
        trigger={null}
        width={300}
        theme="light"
        className={`sider-primary ant-layout-sider-primary`}
        collapsed={collapse}
        collapsible
        style={{ margin: "10px 0 10px 4px", backgroundColor: "transparent" }}
      >
        <Sidenav onCollapse={(v) => setCollapse(v)} collapse={collapse} />
      </Sider>
      <Layout
        style={{
          padding: 0,
          paddingLeft: 20,
          marginLeft: collapse ? 100 : 260,
        }}
      >
        <Affix>
          <AntHeader className={"ant-header-fixed"}>
            <Header title={""} />
          </AntHeader>
        </Affix>

        <FloatButton
          onClick={() => {
            navigate("/billing");
          }}
          tooltip={<div>Generate Bill</div>}
          icon={<FiPlus size={18} />}
          type="primary"
          shape="circle"
          style={{
            transform: "scale(1.2)",
          }}
        />

        <Content className="content-ant">{children}</Content>
      </Layout>
    </Layout>
  );
}

export default Main;
